import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    SingleLine: '',
    Email: '',
    PhoneNumber_countrycode: '',
    SingleLine1: '',
    MultiLine: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-container">
          <h1 className="contact-hero-title">Get in Touch</h1>
          <p className="contact-hero-description">
            Let's discuss how we can help your business achieve its technology goals
          </p>
        </div>
      </section>

      <section className="contact-content">
        <div className="contact-container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="contact-section-title">Contact Information</h2>
              
              <div className="contact-info-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h3 className="contact-info-label">Phone</h3>
                  <a href="tel:+12086562655" className="contact-info-value">(208) 656-2655</a>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h3 className="contact-info-label">Email</h3>
                  <a href="mailto:info@vertechnology.com" className="contact-info-value">info@vertechnology.com</a>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">⏰</div>
                <div>
                  <h3 className="contact-info-label">Business Hours</h3>
                  <p className="contact-info-value">Monday - Friday: 8:00 AM - 5:00 PM PST</p>
                </div>
              </div>

              <div className="contact-info-box">
                <h3 className="contact-info-box-title">Why Choose VerTech?</h3>
                <ul className="contact-info-list">
                  <li>20+ years of technology expertise</li>
                  <li>200+ satisfied customers</li>
                  <li>Vendor-neutral solutions</li>
                  <li>On-time, on-budget, on-quality delivery</li>
                  <li>Comprehensive technology services</li>
                </ul>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <h2 className="contact-section-title">Send Us a Message</h2>
              <form 
                action='https://forms.zohopublic.com/vertech1/form/ContactUs1/formperma/uxAuTWeVSg2NDWmspPSfdlAVQ3yOusI6crS91gg5Ras/htmlRecords/submit' 
                name='form' 
                id='form' 
                method='POST' 
                accept-charset='UTF-8' 
                enctype='multipart/form-data'
                className="contact-form"
              >
                <input type="hidden" name="zf_referrer_name" value="" />
                <input type="hidden" name="zf_redirect_url" value="" />
                <input type="hidden" name="zc_gad" value="" />

                <div className="form-group">
                  <label htmlFor="SingleLine" className="form-label">Full Name *</label>
                  <input
                    type="text"
                    id="SingleLine"
                    name="SingleLine"
                    value={formData.SingleLine}
                    onChange={handleChange}
                    required
                    maxLength="255"
                    className="form-input"
                    placeholder="Your name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="Email" className="form-label">Email *</label>
                  <input
                    type="text"
                    id="Email"
                    name="Email"
                    value={formData.Email}
                    onChange={handleChange}
                    required
                    maxLength="255"
                    fieldType="9"
                    className="form-input"
                    placeholder="your.email@company.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="PhoneNumber_countrycode" className="form-label">Phone</label>
                  <input
                    type="text"
                    id="PhoneNumber_countrycode"
                    name="PhoneNumber_countrycode"
                    compname="PhoneNumber"
                    phoneFormat="1"
                    isCountryCodeEnabled="false"
                    value={formData.PhoneNumber_countrycode}
                    onChange={handleChange}
                    maxLength="20"
                    fieldType="11"
                    className="form-input"
                    placeholder="(555) 123-4567"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="SingleLine1" className="form-label">Company</label>
                  <input
                    type="text"
                    id="SingleLine1"
                    name="SingleLine1"
                    value={formData.SingleLine1}
                    onChange={handleChange}
                    maxLength="255"
                    fieldType="1"
                    className="form-input"
                    placeholder="Your company name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="MultiLine" className="form-label">Message *</label>
                  <textarea
                    id="MultiLine"
                    name="MultiLine"
                    value={formData.MultiLine}
                    onChange={handleChange}
                    required
                    maxLength="65535"
                    rows="6"
                    className="form-textarea"
                    placeholder="Tell us about your project or technology needs..."
                  />
                </div>

                <button type="submit" className="btn-contact-submit">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
